import React, { Component } from "react";
import {
	BrowserRouter as Router,
	Route,
	Link,
	Redirect
} from "react-router-dom";
import { Layout, Menu, Breadcrumb, Icon, Carousel } from "antd";
import Loadable from "react-loadable";
import imgIcon from "../../asset/partner.jpg";
import hci from "../../asset/HCI.png";
import { Swiper, SwiperSlide } from "swiper/react";
import SwiperCore, {
	Navigation,
	Pagination,
	Scrollbar,
	A11y,
	Autoplay
} from "swiper";
import virt from "../../asset/Virt.png";

import "swiper/swiper-bundle.css";

SwiperCore.use([Autoplay, Pagination]);

const Loading = () => <div>Loading...</div>;

const Login = Loadable({
	loader: () => import("../Login"),
	loading: Loading
});
const Logined = Loadable({
	loader: () => import("../Logined"),
	loading: Loading
});

const { Header, Content, Footer, Sider } = Layout;
const SubMenu = Menu.SubMenu;

export default class Home extends React.Component {
	render() {
		return (
			<Layout style={{ minHeight: "100vh" }}>
				<Header style={{ color: "#FFF" }}>渠道商统一登陆</Header>
				<Content className="main">
					<div className="sider-image">
						<Swiper
							loop
							pagination={{
								bulletClass:
									"swiper-pagination-bullet custom-swiper-pagination-bullet",
								bulletActiveClass:
									"swiper-pagination-bullet-active custom-swiper-pagination-bullet-active",
								clickable: true
							}}
							allowTouchMove={false}
							autoplay={{ disableOnInteraction: false }}
						>
							<SwiperSlide>
								<a
									href="https://www.ucloud.cn/site/active/uhost-amd.html"
									target="_blank"
									rel="noopener noreferrer"
								>
									<img src={imgIcon} alt="uhost-amd" />
								</a>
							</SwiperSlide>
							<SwiperSlide>
								<a
									href="https://www.ucloudstack.com/product-hci"
									target="_blank"
									rel="noopener noreferrer"
								>
									<img src={hci} alt="hci" />
								</a>
							</SwiperSlide>
							<SwiperSlide>
								<a
									href="https://www.ucloudstack.com/product-virt"
									target="_blank"
									rel="noopener noreferrer"
								>
									<img src={virt} alt="virt" />
								</a>
							</SwiperSlide>
						</Swiper>
					</div>
					<div className="route-container">
						<Route exact path="/" component={Login} />
						<Route path="/login" component={Login} />
						<Route path="/logined" component={Logined} />
					</div>
				</Content>
				{/* <Footer style={{ textAlign: 'center', width: '100%', position: 'absolute', bottom: 0 }}>
					渠道统一登录平台 @2019 Created by THB
				</Footer> */}
			</Layout>
		);
	}
}
